import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {MachinesCheckpointModelService} from '../../../Models/Tasks/Appccs/machines-checkpoint-model.service';
import {MachineAppccStoreForm} from '../../../../Models/Tasks/Appccs/Checkpoints/machine-appcc-store.model';

@Injectable({
  providedIn: 'root'
})
export class MachinesCheckpointApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: MachinesCheckpointModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los puntos de control de las máquinas
   *
   */
  getMachinesCheckpoints(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getMaquinas', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener los detalles de una máquina
   *
   */
  getMachineDetail(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getMaquina', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar una máquina
   *
   */
  saveMachine(form: MachineAppccStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setMaquina', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar máquina
   *
   */
  deleteMachine(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteMaquina', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Activar/Desactivar una máquina
   *
   */
  toggleMachine(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('maquinaToggleActivo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Enviar mensaje
   *
   */
  sendMessageNotebook(form: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setNotaMaquina', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
